import { createStore } from 'vuex'
import { coreuiStore } from './coreui.module'
import { authModule } from './auth.module'
export default createStore({
  modules: { coreuiStore, authModule },
})
